<template>
  <v-row dense>
    <v-col>
      <navigation-drawer
        color="white"
        :depth="1"
        permanent
        clipped
        fixed
        class="pt-4"
      >
        <v-list dense>
          <v-list-item dense class="px-0 mb-10">
            <v-timeline dense>
              <v-timeline-item
                :color="item.id === attendanceId ? 'primary' : 'gray lighten-1'"
                v-for="item in attendances"
                :key="item.id"
                small
              >
                <v-row dense>
                  <v-col>
                    <v-btn text block small @click="attendance = item">
                      {{ formattedAttendanceDate(item.createdAt) }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-timeline-item>
            </v-timeline>
          </v-list-item>
        </v-list>
      </navigation-drawer>

      <v-row style="padding-left: 170px">
        <v-col>
          
          <v-row align="center">
            <v-col class="text-h3 gray--text text--lighten-1" cols="auto">
              Atendimentos
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="auto">
              <ChipTooltip
                v-if="attendance"
                :content="attendance.employee.name"
                :icon="{ name: 'ri-stethoscope-line', size: 'medium' }"
                :tooltipContent="'Médico responsável'"
              />
            </v-col>

            <v-col cols="auto">
              <ChipTooltip
                v-if="attendance"
                :content="attendance.serviceType.name"
                :icon="{ name: 'mdi-face-agent', size: 'medium' }"
                :tooltipContent="'Tipo de atendimento oferecido'"
              />
            </v-col>
            <v-col cols="auto">
              <ChipTooltip
                v-if="attendance"
                :content="attendance.healthInsuranceProductName"
                :icon="{ name: 'mdi-credit-card', size: 'medium' }"
                :tooltipContent="'Convênio do cliente'"
              />
            </v-col>

            <v-col cols="auto">
              <ChipTooltip
                v-if="attendance"
                :content="attendance.unit.name"
                :icon="{ name: 'mdi-hospital', size: 'medium' }"
                :tooltipContent="'Convênio do cliente'"
              />
            </v-col>

            <v-spacer />

            <v-col cols="auto">
              <v-btn
                class="mb-0"
                color="light-blue"
                dark
                @click="openMedicalRecord(attendance)"
              >
                <v-icon dark left> eva-external-link-outline </v-icon>Prontuário
              </v-btn>
            </v-col>

            <v-col cols="auto">
              <v-btn
                class="mb-0"
                color="light-blue"
                dark
                @click="openMedicalRequest(attendance)"
              >
                <v-icon dark left> eva-external-link-outline </v-icon>Solicitações
              </v-btn>
            </v-col>

            <v-col cols="auto">
              <AttendanceEsign
                :attendance="attendance"
                v-if="attendance && attendance.lastEsign.status !== 'editable'"
              />
            </v-col>
          </v-row>

          <Sumary :attendance="attendance" v-if="attendance" />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import AttendanceEsign from "@/components/attendance/attendance_esign.vue";
import Sumary from "@/components/sumary/index.vue";
import ChipTooltip from "@/components/ui/chip/ChipTooltip.vue";

export default {
  props: {
    patient: Object,
  },
  components: {
    Sumary,
    AttendanceEsign,
    ChipTooltip,
  },
  data() {
    return {
      attendance: null,
    };
  },
  mounted() {
    this.attendance = this.lodash.first(this.attendances);
  },
  computed: {
    attendances() {
      return this.lodash.orderBy(
        this.patient.attendances,
        ["createdAt"],
        ["desc"]
      );
    },
    attendanceId() {
      if (this.attendance?.id) {
        return this.attendance.id;
      }

      return "";
    },
  },
  methods: {
    openMedicalRecord(attendance) {
      this.$router.push({
        path: `/prontuario/${attendance.id}/pre-exame`,
        query: { redirectTo: this.$route.fullPath },
      });
    },
    openMedicalRequest(attendance) {
      this.$router.push({
        path: `/prontuario/${attendance.id}/solicitacao-exames`,
        query: { redirectTo: this.$route.fullPath },
      });
    },
    formattedAttendanceDate(date) {
      if (!date) return "";

      return this.$moment(date).format("DD/MM/YYYY");
    },
  },
};
</script>

<style lang="scss" scoped></style>
